<template>
  <div class="xcard">
    <v-toolbar-title class="mb-5 py-2" style="border-bottom: 1px solid #d4dbe0">
      <span>GESTIONES</span>
    </v-toolbar-title>

    <v-row>
      <v-col cols="12" md="9" xl="10" class="pa-2 pb-0">
        <v-btn
          small
          color="primary"
          class="mr-2"
          @click="$refs.modalFormGestion.abrir('registrar', [])"
          title="Registrar">
          <v-icon>mdi-plus</v-icon>
        </v-btn>

        <v-btn
          small
          class="mr-2"
          :disabled="item == null || item.presupuestos.length > 0"
          @click="$refs.modalFormGestion.abrir('editar', item)"
          title="Editar">
          <v-icon>mdi-pencil</v-icon>

          Editar
        </v-btn>

        <v-btn
          small
          class="mr-2"
          :disabled="item == null || item.presupuestos.length > 0"
          title="Eliminar"
          @click="() => confirmacionAccion(accionesAConfirmar.ELIMINAR, item.numero)">
          <v-icon>mdi-close</v-icon>

          Eliminar
        </v-btn>

        <v-btn
          small
          class="mr-2"
          :disabled="item == null || item.eliminado_en == null"
          title="Activar"
          @click="() => confirmacionAccion(accionesAConfirmar.ACTIVAR, item.numero)">
          <v-icon>mdi-check-circle-outline</v-icon>

          Activar
        </v-btn>

        <v-btn
          small
          class="mr-2"
          :disabled="item == null || item.eliminado_en != null"
          title="Desactivar"
          @click="() => confirmacionAccion(accionesAConfirmar.DESACTIVAR, item.numero)">
          <v-icon>mdi-close-circle-outline</v-icon>

          Desactivar
        </v-btn>

        <v-btn small class="mr-2" @click="listar" title="Recargar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="12" md="3" xl="2" class="pa-2 pb-0">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="updateSearchQuery"></v-text-field>
      </v-col>

      <v-col cols="12" class="pa-2 pb-4">
        <ListadoGestion ref="listadoRef" :items="items" :cargando="cargando" @selectItem="selectItem" />
      </v-col>
    </v-row>

    <ModalFormGestion ref="modalFormGestion" :nombreRecurso="nombreRecurso" @actualizarListado="listar" />

    <ConfirmacionAccion
      ref="confirmacionRef"
      :titulo="confirmacion.titulo"
      :mensaje="confirmacion.mensaje"
      :realizandoAccion="confirmacion.realizandoAccion"
      @aceptar="confirmacion.fnAceptar" />

    <notifications group="notifications" position="top right" />
  </div>
</template> 

<script>
import LayoutMixin from '../mixins/layout-mixin';
import ListadoGestion from '../views/ListadoGestion.vue';
import ModalFormGestion from '../components/ModalFormGestion.vue';
import 'vue-select/dist/vue-select.css';
import GestionesService from '../services/gestion';

export default {
  mixins: [LayoutMixin],
  components: {
    ListadoGestion,
    ModalFormGestion,
  },
  data() {
    return {
      servicioListarItems: GestionesService.get,
      nombreRecurso: 'GESTIÓN',
    };
  },
  mounted() {
    this.listar();
  },
  methods: {
    async listar() {
      const params = {
        con_eliminados: true,
        orden_en: 'DESC',
      };

      this.listarMixin(params);
    },
    async getResponseAccion(accion) {
      let response = null;

      if (accion === this.accionesAConfirmar.ACTIVAR) {
        response = await GestionesService.activate(this.item.id);
      } else if (accion === this.accionesAConfirmar.DESACTIVAR) {
        response = await GestionesService.deactivate(this.item.id);
      } else if (accion === this.accionesAConfirmar.ELIMINAR) {
        response = await GestionesService.destroy(this.item.id);
      }

      return response;
    },
  },
};
</script>

<style scoped>
::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}
::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}
::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}
</style>
    